module.exports = __webpack_public_path__ + "static/media/aiDesignerTemplate2.f0e7d81e.png";